
import { useTranslation } from 'react-i18next'
import styled from 'styled-components/macro'
import newFilters from '../../assets/newFilters.png'
import arrow from '../../assets/arrowSub.svg'
import { useDispatch } from 'react-redux'
import { setFilter } from '../../redux/slices/categories'


const Root = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-bottom: 16px;
    border-bottom: 1px solid #E9E5E2;
    color: #4D4D4D;
    width: 100%;

    @media (max-width: 1024px){  
        flex-direction: column;
        align-items: flex-start;

    }
`

const Filter = styled.div`
    display: flex;
    align-items: center;
    font-family: 'Montserrat';
    font-weight: 300;
    font-size: 16px;
    cursor: pointer;
    gap: 14px;
    margin-top: 12px;

    @media (max-width: 577px){  
        font-size: 10px;
        margin-right: 10px;
    }
`

const Categories = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: Palatino Linotype;
    font-weight: 400;
    font-size: 24px;
    gap: 70px;

    @media (max-width: 577px){  
        font-size: 14px;
        gap: 25px;
    }
`

const Category = styled.div`
    display: flex;
    align-items: center;
    cursor: pointer;
    border-bottom:${props => props.isActive && '2px solid #FFDBC6'};

    @media (max-width: 1024px){  
        padding-top: 10px;
        font-size: 18px;
    }
`

const Title = styled.div`
    display: flex;
    align-items: center;
    font-family: Palatino Linotype;
    font-weight: 400;
    font-size: 32px;
    flex: 0 0 43%;
    box-sizing: border-box;

    @media (max-width: 1024px){  
        border-bottom: 1px solid #E9E5E2;
        width: 100%;
        flex: 1 1 auto;
        padding: 0 10px 10px;
        font-size: 25px;
        padding-top: 10px;
        padding-bottom: 5px;
    }

    @media (max-width: 577px){  
        font-size: 25px;
        padding-bottom: 5px;
    }
`

const RestWrapper = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
    justify-content: space-between;
    box-sizing: border-box;

    @media (max-width: 1024px){  
        width: 100%;
        align-items: center;
        flex: 1 1 auto;
        padding: 0 60px 0 10px;
    }

    @media (max-width: 577px){  
        width: 100%;
        align-items: center;
        flex: 1 1 auto;
        padding: 0 0 0 10px;
    }
`

const BurgerImg =styled.img`
    display: flex;
    padding: 0;
    width: 16px;
    height: 10px;

    @media (max-width: 577px){  
        display: none;
    }
`

const ArrowImg =styled.img`
    display: none;
    padding: 0;
    width: 14px;

    @media (max-width: 577px){  
        display: flex;
    }
`


const TitleBlock = ({title, setShowFilter, currentFIlter, isShowFilter}) => {
    const { t } = useTranslation()
    const dispatch = useDispatch();

    const filterSubmitHandler = (value) => {
        dispatch(setFilter({
            ...currentFIlter,
            cathegory: value,
            subcathegory: ''
        }))
    }
    
  return (
      <Root>
            <Title>
                {title}
            </Title>
            <RestWrapper>
                <Categories>
                    <Category isActive={currentFIlter.cathegory === 'teddy'} onClick={() => filterSubmitHandler('teddy')}>{t('teddy')}</Category>
                    <Category isActive={currentFIlter.cathegory === 'doll'} onClick={() => filterSubmitHandler('doll')}>{t('dolls')}</Category>
                </Categories>
                <Filter onClick={() => setShowFilter(!isShowFilter)}>
                    <div style={{fontSize: 14}}>{t('filter')}</div>
                    <BurgerImg src={newFilters} alt="burger" />
                    <ArrowImg src={arrow} alt="arrow" />
                </Filter>
            </RestWrapper>
            
      </Root>
  )
}

export default TitleBlock